<template>
  <div class="back_img">
    <div class="title">易维迅轨道交通集成管理平台设备运维服务平台软件V1.0</div>
    <div class="login_card">
      <el-container>
        <el-aside width="500px"><img src="../assets/imgs/login500x400.png"
            style=" border-top-left-radius: 5px;border-bottom-left-radius: 5px;">
        </el-aside>
        <el-main style="padding:20px">
          <div class="login_title">系统登录</div>
          <el-form :model="login" :rules="rules" ref="loginform">
            <el-form-item prop="loginNo">
              <el-input v-model="login.loginNo" placeholder="账号" clearable readonly
                @focus="(event) => { event.currentTarget.removeAttribute('readonly') }">
                <i class="el-icon-user" slot="prefix"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="login.password" placeholder="密码" clearable
                @keyup.enter.native="submit()">
                <i class="el-icon-lock" slot="prefix"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width:100%" :loading="edit_loading" @click="submit()">登 录</el-button>
            </el-form-item>
          </el-form>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import dyrouter from '../utils/dyrouter'
export default {
  name: 'login',
  data () {
    return {
      edit_loading: false,
      login: {
        loginNo: '',
        password: '',
      },
      rules: {
        loginNo: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { max: 40, message: '不能超过40个字符', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {

    submit () {
      this.$refs['loginform'].validate((valid) => {
        if (valid) {
          this.edit_loading = true
          this.$ajax.post('/base/login', this.login).then((msg) => {
            //缓存到本地
            localStorage.setItem("user", JSON.stringify(msg));
            this.$store.storeUser(msg)
            dyrouter.addRouter(JSON.parse(this.$store.getUser().menus))
            this.$router.push('/main')
          }).catch(err => {
            this.$message.error(err);
          }).finally(() => {
            this.edit_loading = false
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.back_img {
  overflow: hidden;
  background-image: url("../assets/imgs/back1920x1080.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  width: 100vw;
}

.login_card {
  background-color: white;
  position: absolute;
  left: calc(50vw - 400px);
  top: calc(50vh - 160px);
  width: 800px;
  height: 400px;
  border-radius: 5px;
}

.title {
  width: 800px;
  text-align: left;
  color: white;
  position: absolute;
  left: calc(50vw - 400px);
  top: calc(50vh - 230px);
  font-size: 30px;
  font-weight: bolder;
  letter-spacing: 4px;
}

.title span {
  font-size: 24px;
  letter-spacing: 4px;
  position: absolute;
  top: 8px;
}

.login_title {
  color: #409eff;
  text-align: center;
  font-size: x-large;
  font-weight: bolder;
  letter-spacing: 2px;
  margin-top: 40px;
  margin-bottom: 20px;
}

.logo {
  position: absolute;
  bottom: 10px;
  right: 20px;
  width: 100px;
}
</style>
